import script from "./Benchmarking.vue?vue&type=script&setup=true&lang=js"
export * from "./Benchmarking.vue?vue&type=script&setup=true&lang=js"

import "./Benchmarking.vue?vue&type=style&index=0&id=bbe94762&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bbe94762"]])

export default __exports__